export const MFA_SESSION_ALL_ISSUES_LABELS = {
	FILTERS_ARIA_LABEL: "MFA Session's all issues filters",
	TABLE_ARIA_LABEL: "MFA Session's all issues table",
	TABLE_TITLE: 'MFA Session Issues',
	TABLE_CAPTION: 'MFA Session Issues table',
	ISSUES_DATA_TYPE: 'issues'
};
